// extracted by mini-css-extract-plugin
module.exports = {"landingRoot":"landing_landingRoot__l55gQ","landingPc":"landing_landingPc__EDnGW"};